import React, { memo, useCallback, useState, KeyboardEvent } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import TooltipItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/TooltipItem';
import { IconQuestion01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import * as S from './style';

interface IProps {
  type: 'left' | 'right';
  text?: string;
  className?: string;
  onClose?: () => void;
}

const TooltipBox = ({ type = 'left', text, className, onClose }: IProps) => {
  const cName = classNameBind(['tooltip-popup', className || '']);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const handleClose = useCallback(() => {
    setTooltipVisible(false);
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  const toggleTooltip = useCallback(
    (
      e:
        | React.MouseEvent<HTMLDivElement, MouseEvent>
        | React.KeyboardEvent<HTMLDivElement>
    ) => {
      e.preventDefault();
      e.stopPropagation();
      setTooltipVisible(prev => !prev);
    },
    []
  );

  const handleKeyDown = useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter' || e.key === ' ') {
        toggleTooltip(e);
      }
    },
    [toggleTooltip]
  );

  return (
    <S.TooltipBox className={cName} type={type}>
      <div
        className="question-mark"
        onClick={toggleTooltip}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-label="툴팁 열기"
        aria-expanded={tooltipVisible}
      >
        <IconQuestion01 />
      </div>
      {tooltipVisible && (
        <TooltipItem text={text} type={type} onClose={handleClose} />
      )}
    </S.TooltipBox>
  );
};

export default memo(TooltipBox);
